const e = "Account", n = "Rekeningsaldo", t = "Accountbeschrijving", a = "Account-ID", o = "Aanvullingen", r = "Aanpassingen", i = "Bedrag", d = "en", s = "Toepassen", l = "Terug", c = "Saldorekening", g = "ID saldorekening", u = "Geboekt", p = "Vastgehouden", m = "Categorie", f = "Chargebacks", b = "Sluiten", k = "Neem contact op met support", v = "Neem contact op met support voor hulp.", h = "Neem contact op met support voor hulp en vermeld de foutcode %{requestId}", y = "Gekopieerd", T = "Kopiëren", w = "Correcties", A = "Valuta", j = "Datum", R = "Periode", P = "Beschrijving", C = "Negeren", N = "Downloaden", S = "Downloaden", F = "E-mailadres", O = "Entiteit is niet gevonden.", D = "Transactie niet gevonden voor de opgegeven rekeninghouder", W = "Kosten", z = "Bestand", x = "Filterbalk", B = "Van", I = "Volledig", L = "Vastgehouden bedrag", E = "Terug", V = "Subsidie verleend", G = "Terugbetalingen van subsidies", M = "Inhoud verbergen", q = "ID", J = "Onvolledig veld", U = "Wordt aan gewerkt", H = "Bezig met laden", K = "max", Y = "min", _ = "Mobiel", X = "Netto uitbetaling", Z = "Volgende uitbetalingen", Q = "Geen gegevens", $ = "Negatieve getallen zijn niet toegestaan", ee = "Geen uitbetalingen gevonden", ne = "Geen rapporten gevonden", te = "Geen transacties gevonden", ae = "Overige", oe = "Gepagineerde navigatie", re = "Gedeeltelijk", ie = "Betalings-ID", de = "Betaalmethode", se = "Uitbetalingsgegevens", le = "Uitbetalingsinformatie wordt elke dag om middernacht, UTC-tijd, gegenereerd.", ce = "Uitbetalingen", ge = "In behandeling", ue = "Kom later terug.", pe = "Neem contact op support voor ondersteuning.", me = "Neem contact met support", fe = "Referentie-ID", be = "Vernieuwen", ke = "Refunds", ve = "Betaling terugbetalen", he = "We konden de terugbetaling niet verwerken. Probeer het later opnieuw.", ye = "Er is iets fout gegaan.", Te = "Je klant ontvangt het geld binnen maximaal 40 dagen. Wanneer de terugbetaling is gelukt, zie je een nieuwe terugbetalingstransactie in je lijst.", we = "Terugbetaling verzonden!", Ae = "Terug te betalen bedrag", je = "Terugbetalingen kunnen tot 40 dagen duren, afhankelijk van de betalingsmethode. Kosten zijn inbegrepen.", Re = "%{amount} terugbetalen", Pe = "Reden voor terugstorting", Ce = "Referentie", Ne = "Resterend bedrag", Se = "Rapport", Fe = "Rapporten worden elke dag om middernacht, UTC-tijd, gegenereerd.", Oe = "Rapporten", De = "Resetten", We = "Teruggestort", ze = "Er is iets fout gegaan.", xe = "Er is iets misgegaan. Probeer de pagina te vernieuwen of kom later terug.", Be = "Status", Ie = "Gestructureerde lijst", Le = "Aftrekkingen", Ee = "Som van uitbetalingen op dezelfde dag", Ve = "Tabs", Ge = "De foutcode is %{requestId}", Me = "Er zijn geen resultaten", qe = "Er ontbreken verplichte velden in het verzoek of het bevat ongeldige gegevens.", Je = "Er is een onverwachte fout opgetreden", Ue = "De geselecteerde saldorekening is onjuist", He = "Tijdzone", Ke = "Naar", Ye = "Totaal inkomend", _e = "Totaal uitgaand", Xe = "De waarde moet gelijk zijn aan of groter zijn dan de Van-waarde", Ze = "Gegevens van de transactie", Qe = "Transacties", $e = "Transactieoverzicht", en = "Soort transactie", nn = "Overschrijvingen", tn = "Probeer een andere zoekopdracht of stel uw filters opnieuw in, en we proberen het opnieuw.", an = "Probeer de pagina te vernieuwen of kom later terug.", on = "Bedrag", rn = "Soort", dn = "Waarde", sn = "We konden het uitbetalingsoverzicht niet laden.", ln = "We konden het rapportoverzicht niet laden.", cn = "We konden het transactieoverzicht niet laden.", gn = "We konden je saldorekeningen niet laden.", un = "We konden je uitbetalingen niet laden.", pn = "We konden je rapporten niet laden.", mn = "We konden je transacties niet laden.", fn = {
  account: e,
  accountBalance: n,
  accountDescription: t,
  accountID: a,
  additions: o,
  adjustments: r,
  amount: i,
  and: d,
  apply: s,
  back: l,
  balanceAccount: c,
  balanceAccountId: g,
  Booked: u,
  "button.clearAll": "Alles wissen",
  "calendar.controls": "Bedieningselementen voor agendanavigatie",
  "calendar.nextMonth": "Volgende maand",
  "calendar.previousMonth": "Vorige maand",
  "calendar.timezone": "Tijdzone is ingesteld op: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Je account is inactief",
  "capital.actionNeeded": "Actie nodig",
  "capital.bankAccountDetails": "Bankrekeninggegevens",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Rekeningnummer",
  "capital.bankCountryOrRegion": "Land/regio",
  "capital.bankRoutingNumber": "Routeringsnummer",
  "capital.bankSortCode": "Sort code",
  "capital.businessFinancing": "Zakelijke financiering",
  "capital.businessFinancingOffer": "Aanbod voor zakelijke financiering",
  "capital.businessFinancingSummary": "Samenvatting zakelijke financiering",
  "capital.closed": "Gesloten",
  "capital.couldNotContinueWithTheOffer": "We konden niet doorgaan met het aanbod.",
  "capital.couldNotLoadFinancialOffers": "We konden geen financiële aanbiedingen laden.",
  "capital.dailyRepaymentRate": "Dagelijks terugbetalingspercentage",
  "capital.daysAndDaysLeft": "%{days} dagen (%{daysLeft} dagen resterend)",
  "capital.expectedRepaymentPeriod": "Verwachte terugbetalingsperiode",
  "capital.failed": "Mislukt",
  "capital.fees": "Kosten",
  "capital.fullyRepaid": "Volledig terugbetaald",
  "capital.goToTermsAndConditions": "Naar de algemene voorwaarden",
  "capital.grantID": "Subsidie-ID",
  "capital.howMuchMoneyDoYouNeed": "Hoeveel geld heb je nodig?",
  "capital.inProgress": "Wordt aan gewerkt",
  "capital.legalSubtitleAU": "Adyen Capital wordt aangeboden door Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Leningen worden verstrekt door Adyen N.V.",
  "capital.legalSubtitleGB": "Leningen worden verstrekt door Adyen N.V., vertegenwoordigd door haar Londense vestiging.",
  "capital.legalSubtitleUS": "Leningen worden verstrekt door Adyen N.V. San Francisco Branch en zijn onder voorbehoud van kredietgoedkeuring.",
  "capital.maximumRepaymentPeriod": "Maximale terugbetalingsperiode",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Minimale terugbetaling elke %{days} dagen om de financiering op tijd terug te betalen",
  "capital.needSomeExtraMoney": "Heb je wat extra geld nodig?",
  "capital.offerLegalNoticeDescriptionUS": "Als je aanvraag voor zakelijk krediet wordt afgewezen, heb je recht op een schriftelijke verklaring met de specifieke redenen voor de afwijzing. Neem om de verklaring op te vragen binnen 60 dagen na de datum waarop je van onze beslissing op de hoogte bent gesteld contact op met het Credit Support Team van Adyen door een e-mail te sturen naar %{email}. We sturen je binnen 30 dagen na ontvangst van je verzoek een schriftelijke verklaring met de redenen voor de afwijzing. %{break} De Federal Equal Credit Opportunity Act verbiedt kredietverstrekkers om kredietaanvragers te discrimineren op grond van ras, huidskleur, godsdienst, nationale herkomst, geslacht, burgerlijke staat, leeftijd (mits de aanvrager de wettelijke bevoegdheid heeft om een bindend contract aan te gaan), het feit dat het inkomen van de aanvrager geheel of gedeeltelijk afkomstig is van een programma voor maatschappelijke bijstand, of het feit dat de aanvrager te goeder trouw een recht heeft uitgeoefend onder de Consumer Credit Protection Act. De federale instantie die toeziet op de naleving van deze wet met betrekking tot deze kredietverstrekker is het Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Kredietverlener: Adyen N.V. - San Francisco Branch %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 maand",
  "capital.pending": "In behandeling",
  "capital.primaryAccount": "Hoofdrekening",
  "capital.remaining": "Over",
  "capital.remainingAmount": "Resterend bedrag",
  "capital.remainingFees": "Resterende kosten",
  "capital.repaid": "Terugbetaald",
  "capital.repaidAmount": "Terugbetaald bedrag",
  "capital.repaidFees": "Terugbetaalde kosten",
  "capital.repaymentBalanceInfo": "Je huidige openstaande bedrag, inclusief kosten, is %{amount}",
  "capital.repaymentThreshold": "Terugbetalingsdrempel",
  "capital.requestedFunds": "Aangevraagde financiering",
  "capital.requestFunds": "Financiering aanvragen",
  "capital.requesting": "Wordt aangevraagd",
  "capital.reviewOffer": "Aanbod controleren",
  "capital.revoked": "Ingetrokken",
  "capital.seeNewOffer": "Nieuw aanbod bekijken",
  "capital.seeOptions": "Opties bekijken",
  "capital.sendRepayment": "Terugbetaling verzenden",
  "capital.sendRepaymentNotice": "De extra terugbetaling via bankoverschrijving voor je lening wordt over twee tot drie werkdagen verwerkt en zichtbaar op je leningrekening.",
  "capital.sendRepaymentSubtitle": "Maak geld over naar deze bankrekening om (een deel van) je lening af te betalen.",
  "capital.signTermsAndConditionsToReceiveFunds": "Onderteken de algemene voorwaarden om je geld te ontvangen.",
  "capital.signTheTermsToReceiveYourFunds": "Onderteken de voorwaarden om je geld te ontvangen",
  "capital.termEnds": "Einddatum voorwaarden: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Er is geen hoofdaccount ingesteld",
  "capital.thisOfferExpiresOn": "Dit aanbod vervalt op %{date}.",
  "capital.totalFees": "Totale kosten",
  "capital.totalRepaymentAmount": "Totaal terugbetalingsbedrag",
  "capital.unsupportedRegionDescription": "Zakelijke financiering is nog niet beschikbaar in jouw regio. Houd deze pagina in de gaten voor een aanbod.",
  "capital.unsupportedRegionTitle": "Houd het in de gaten!",
  "capital.weCouldNotContinueWithTheOffer": "We konden niet doorgaan met het aanbod.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "We konden niet doorgaan met het aanbod. Neem contact op met support voor hulp.",
  "capital.weCouldNotLoadFinancialOffers": "We konden geen financiële aanbiedingen laden.",
  "capital.weCouldNotProcessThisRequestTryAgain": "We konden dit verzoek niet verwerken. Probeer het opnieuw met een nieuw aanbod.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "We hebben je verzoek ontvangen en zijn het aan het verwerken. Kom snel terug voor de volgende stappen.",
  "capital.writtenOff": "Afgeschreven",
  "capital.xDays": "%{days} dagen",
  "capital.xMonths": "%{months} maanden",
  "capital.xPercent": "%{percentage}%",
  "capital.youAcceptedButThenReturnedTheseFunds": "Je hebt dit geld geaccepteerd, maar vervolgens teruggestuurd",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Je hebt dit geld geaccepteerd, maar niet terugbetaald",
  "capital.youAreRequestingFundingOf": "Je vraagt financiering aan van",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Je komt in aanmerking voor bedrijfsfinanciering",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " tot %{amount}.",
  "capital.yourRequestedFundsWere": "Je aangevraagde financiering bedroeg: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Je zou het geld binnen één werkdag moeten krijgen",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Je moet elke %{days} dagen minimaal %{amount} terugbetalen om het eindbedrag volledig af te betalen tegen %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Je komt binnenkort in aanmerking voor een financieel aanbod!",
  capture: p,
  category: m,
  chargeback: f,
  closeIconLabel: b,
  contactSupport: k,
  contactSupportForHelp: v,
  contactSupportForHelpAndShareErrorCode: h,
  copied: y,
  copy: T,
  correction: w,
  currency: A,
  date: j,
  dateRange: R,
  default: "Standaard",
  description: P,
  dismiss: C,
  download: N,
  downloading: S,
  email: F,
  entityWasNotFound: O,
  entityWasNotFoundDetail: D,
  "error.pleaseTryAgainLater": "Probeer het later alsjeblieft opnieuw.",
  "error.somethingWentWrongWithDownload": "Er is iets misgegaan tijdens het downloaden",
  "expandableCard.collapse": "Samenvoegen",
  "expandableCard.expand": "Uitvouwen",
  export: "Exporteren",
  fee: W,
  file: z,
  "filter.date.since": "Sinds %{date}",
  "filter.date.until": "Tot %{date}",
  filterBar: x,
  "filterPlaceholder.category": "Soort",
  "filterPlaceholder.currency": "Valuta",
  "filterPlaceholder.status": "Status",
  from: B,
  full: I,
  fundsCaptured: L,
  goBack: E,
  grantIssued: V,
  grantRepayment: G,
  hideContent: M,
  id: q,
  incompleteField: J,
  inProgress: U,
  loading: H,
  max: K,
  min: Y,
  mobile: _,
  netPayout: X,
  nextPayouts: Z,
  noData: Q,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ne,
  noTransactionsFound: te,
  other: ae,
  paginatedNavigation: oe,
  "pagination.nextPage": "Volgende pagina",
  "pagination.previousPage": "Vorige pagina",
  "pagination.showing": "Tonen",
  partial: re,
  paymentId: ie,
  paymentMethod: de,
  payoutDetails: se,
  payoutsNotice: le,
  payoutsTitle: ce,
  Pending: ge,
  pleaseComeBackLater: ue,
  pleaseReachOutToSupportForAssistance: pe,
  "rangePreset.custom": "Aangepast",
  "rangePreset.last30Days": "Laatste 30 dagen",
  "rangePreset.last7Days": "Laatste 7 dagen",
  "rangePreset.lastMonth": "Vorige maand",
  "rangePreset.lastWeek": "Vorige week",
  "rangePreset.thisMonth": "Deze maand",
  "rangePreset.thisWeek": "Deze week",
  "rangePreset.yearToDate": "Jaar tot heden",
  reachOutToSupport: me,
  referenceID: fe,
  refresh: be,
  refund: ke,
  "refund.amountAlreadyRefunded": "Je hebt al %{amount} terugbetaald",
  "refund.amountFailed": "De terugbetaling van %{amount} is mislukt. Het is momenteel niet mogelijk om dit bedrag terug te laten betalen. Neem contact op met de klantenservice.",
  "refund.amountInProgress": "De gedeeltelijke terugbetaling van %{amount} wordt verwerkt.",
  "refund.fee": "Kost",
  "refund.fullAmountFailed": "Het is niet mogelijk om deze betaling terug te storten. Neem contact op met de klantenservice.",
  "refund.fullAmountRefunded": "Het volledige bedrag is terugbetaald aan de klant",
  "refund.goToPayment": "Ga naar de betaling",
  "refund.maximumRefundable": "Je kunt maximaal %{amount} terugbetalen",
  "refund.onlyRefundable": "Je kunt enkel %{amount} terugbetalen",
  "refund.originalAmount": "Oorspronkelijk bedrag",
  "refund.originalPayment": "Oorspronkelijke betaling",
  "refund.paymentPspReference": "PSP-referentie voor betaling",
  "refund.pspReference": "PSP-referentie",
  "refund.refundFee": "Kosten voor terugbetaling",
  "refund.refundPspReference": "PSP-referentie voor terugbetaling",
  "refund.returnToRefund": "Terug naar terugbetaling",
  "refund.theRefundIsBeingProcessed": "De terugbetaling wordt verwerkt.",
  refundAction: ve,
  refundActionErrorSubtitle: he,
  refundActionErrorTitle: ye,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: we,
  refundAmount: Ae,
  "refundAmount.excess": "Je kunt het beschikbare bedrag van %{amount} niet overschrijden",
  "refundAmount.required": "Een bedrag voor terugbetaling invoeren",
  "refunded.full": "Volledig terugbetaald",
  "refunded.partial": "Gedeeltelijk terugbetaald",
  refundNotice: je,
  refundPayment: Re,
  refundReason: Pe,
  "refundReason.duplicate": "Duplicaat",
  "refundReason.fraudulent": "Frauduleus",
  "refundReason.issue_with_item_sold": "Probleem met verkocht artikel",
  "refundReason.other": "Overige",
  "refundReason.requested_by_customer": "Aangevraagd door de klant",
  refundReference: Ce,
  "refundReference.placeholder": "Voer hier de referentie in",
  remainingAmount: Ne,
  report: Se,
  "reportsError.tooManyDownloads": "We konden niet alle bestanden downloaden. Probeer het later opnieuw.",
  reportsNotice: Fe,
  reportsTitle: Oe,
  "reportType.payout": "Uitbetaling",
  reset: De,
  Reversed: We,
  "select.filter.placeholder": "Placeholder",
  "select.noOptionsFound": "Er zijn geen opties die overeenkomen met deze zoekopdracht",
  somethingWentWrong: ze,
  somethingWentWrongTryRefreshingOrComeBackLater: xe,
  status: Be,
  structuredList: Ie,
  subtractions: Le,
  sumOfSameDayPayouts: Ee,
  tabs: Ve,
  theErrorCodeIs: Ge,
  thereAreNoResults: Me,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: qe,
  thereWasAnUnexpectedError: Je,
  theSelectedBalanceAccountIsIncorrect: Ue,
  timezone: He,
  to: Ke,
  "tooltip.ATM": "Geld opgenomen bij een geldautomaat",
  "tooltip.Capital": "Geld uit een binnenkomende lening of terugbetaling van een uitgaande lening",
  "tooltip.Chargeback": "Geld teruggestort aan een klant na een betwiste transactie",
  "tooltip.Correction": "Aanpassingen aan je geld, inclusief terugboekingen van transacties en correcties op stortingen",
  "tooltip.Fee": "Transactiekosten en kosten voor betaalmethoden",
  "tooltip.Other": "Transacties die niet in een andere categorie vallen, meestal een aanpassing",
  "tooltip.Payment": "Geld dat op je rekening is ontvangen via een verkooptransactie",
  "tooltip.Refund": "Geld dat is teruggestuurd naar een klant in het kader van een teruggestorte transactie",
  "tooltip.totalIncoming": "Al het geld dat op uw rekening is ontvangen op basis van de geselecteerde filters",
  "tooltip.totalOutgoing": "Alle vergoedingen, terugbetalingen, uitbetalingen en andere kosten op basis van de geselecteerde filters",
  "tooltip.Transfer": "Geld dat tussen je rekening en een andere rekening is overgemaakt",
  totalIncoming: Ye,
  totalOutgoing: _e,
  toValueShouldBeGreaterThanTheFromValue: Xe,
  transactionDetails: Ze,
  transactions: Qe,
  transactionsOverviewTitle: $e,
  transactionType: en,
  transfer: nn,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: tn,
  tryRefreshingThePageOrComeBackLater: an,
  txAmount: on,
  "txType.ATM": "Geldautomaat",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Terugboeking",
  "txType.Correction": "Correctie",
  "txType.Fee": "Kost",
  "txType.Other": "Overige",
  "txType.Payment": "Betaling",
  "txType.Refund": "Refund",
  "txType.Transfer": "Overschrijving",
  type: rn,
  value: dn,
  weCouldNotLoadThePayoutsOverview: sn,
  weCouldNotLoadTheReportsOverview: ln,
  weCouldNotLoadTheTransactionsOverview: cn,
  weCouldNotLoadYourBalanceAccounts: gn,
  weCouldNotLoadYourPayouts: un,
  weCouldNotLoadYourReports: pn,
  weCouldNotLoadYourTransactions: mn
};
export {
  u as Booked,
  ge as Pending,
  We as Reversed,
  e as account,
  n as accountBalance,
  t as accountDescription,
  a as accountID,
  o as additions,
  r as adjustments,
  i as amount,
  d as and,
  s as apply,
  l as back,
  c as balanceAccount,
  g as balanceAccountId,
  p as capture,
  m as category,
  f as chargeback,
  b as closeIconLabel,
  k as contactSupport,
  v as contactSupportForHelp,
  h as contactSupportForHelpAndShareErrorCode,
  y as copied,
  T as copy,
  w as correction,
  A as currency,
  j as date,
  R as dateRange,
  fn as default,
  P as description,
  C as dismiss,
  N as download,
  S as downloading,
  F as email,
  O as entityWasNotFound,
  D as entityWasNotFoundDetail,
  W as fee,
  z as file,
  x as filterBar,
  B as from,
  I as full,
  L as fundsCaptured,
  E as goBack,
  V as grantIssued,
  G as grantRepayment,
  M as hideContent,
  q as id,
  U as inProgress,
  J as incompleteField,
  H as loading,
  K as max,
  Y as min,
  _ as mobile,
  X as netPayout,
  Z as nextPayouts,
  Q as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ne as noReportsFound,
  te as noTransactionsFound,
  ae as other,
  oe as paginatedNavigation,
  re as partial,
  ie as paymentId,
  de as paymentMethod,
  se as payoutDetails,
  le as payoutsNotice,
  ce as payoutsTitle,
  ue as pleaseComeBackLater,
  pe as pleaseReachOutToSupportForAssistance,
  me as reachOutToSupport,
  fe as referenceID,
  be as refresh,
  ke as refund,
  ve as refundAction,
  he as refundActionErrorSubtitle,
  ye as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  we as refundActionSuccessTitle,
  Ae as refundAmount,
  je as refundNotice,
  Re as refundPayment,
  Pe as refundReason,
  Ce as refundReference,
  Ne as remainingAmount,
  Se as report,
  Fe as reportsNotice,
  Oe as reportsTitle,
  De as reset,
  ze as somethingWentWrong,
  xe as somethingWentWrongTryRefreshingOrComeBackLater,
  Be as status,
  Ie as structuredList,
  Le as subtractions,
  Ee as sumOfSameDayPayouts,
  Ve as tabs,
  Ge as theErrorCodeIs,
  qe as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  Ue as theSelectedBalanceAccountIsIncorrect,
  Me as thereAreNoResults,
  Je as thereWasAnUnexpectedError,
  He as timezone,
  Ke as to,
  Xe as toValueShouldBeGreaterThanTheFromValue,
  Ye as totalIncoming,
  _e as totalOutgoing,
  Ze as transactionDetails,
  en as transactionType,
  Qe as transactions,
  $e as transactionsOverviewTitle,
  nn as transfer,
  tn as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  an as tryRefreshingThePageOrComeBackLater,
  on as txAmount,
  rn as type,
  dn as value,
  sn as weCouldNotLoadThePayoutsOverview,
  ln as weCouldNotLoadTheReportsOverview,
  cn as weCouldNotLoadTheTransactionsOverview,
  gn as weCouldNotLoadYourBalanceAccounts,
  un as weCouldNotLoadYourPayouts,
  pn as weCouldNotLoadYourReports,
  mn as weCouldNotLoadYourTransactions
};
